import { render, staticRenderFns } from "./PlayerOption.vue?vue&type=template&id=133f622c&scoped=true"
import script from "./PlayerOption.vue?vue&type=script&lang=js"
export * from "./PlayerOption.vue?vue&type=script&lang=js"
import style0 from "./PlayerOption.vue?vue&type=style&index=0&id=133f622c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f622c",
  null
  
)

export default component.exports